// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"225":"921e73f9","354":"f849a08f","838":"273e6e0a"}[chunkId] + ".js";
};